import Box from '@mui/material/Box';
import { LazyLoadable } from '@openx/components-core/lib/LazyLoadable/LazyLoadable';
import { useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router';
import { DealInsightsDelivery } from './components/DealInsightsDelivery/DealInsightsDelivery';
import { DealInsightsDistribution } from './components/DealInsightsDistribution/DealInsightsDistribution';
import { DealInsightsGeneral } from './components/DealInsightsGeneral/DealInsightsGeneral';
import { DealInsightsHeader } from './components/DealInsightsHeader/DealInsightsHeader';
import { DEAL_INSIGHTS_PATH, DEAL_INSIGHTS_PATHS, TABS } from './constants';
import { getLastPathSegment } from './utils/tabUtils';

// Deferred: pulls in the chart.js/chartjs-chart-geo/d3-geo/topojson map-rendering stack, only needed on this one tab
const DealInsightsGeolocation = LazyLoadable(
  () => import('./components/DealInsightsGeolocation/DealInsightsGeolocation'),
  'DealInsightsGeolocation'
);

export const DealInsights = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const currentPath = getLastPathSegment(location.pathname);

  const isValidPath = TABS.some(tab => tab.path === currentPath);

  useEffect(() => {
    if (!isValidPath && location.pathname !== DEAL_INSIGHTS_PATH) {
      navigate(DEAL_INSIGHTS_PATH);
    }
  }, [isValidPath, location.pathname, navigate]);

  return (
    <Box>
      <DealInsightsHeader />
      <Box>
        <Routes>
          <Route index element={<DealInsightsGeneral />} />
          <Route path={DEAL_INSIGHTS_PATHS.distribution} element={<DealInsightsDistribution />} />
          <Route path={DEAL_INSIGHTS_PATHS.delivery} element={<DealInsightsDelivery />} />
          <Route path={DEAL_INSIGHTS_PATHS.geolocation} element={<DealInsightsGeolocation />} />
        </Routes>
      </Box>
    </Box>
  );
};
